export const resolveTerminal = (code, terminalData) => {
    if (!code) return null;

    const spMatch = code.match(/^SP(\d+(?:\.\d+)?)\/?(\d+(?:\.\d+)?)$/);
    if (spMatch) {
        return { len: parseFloat(spMatch[1]), peel: parseFloat(spMatch[2]) };
    }

    return terminalData[code] || null;
};

export const needsInnerStripping = (cable, terminalData) => {
    if (!cable.poli || !Array.isArray(cable.poli)) return false;

    return cable.poli.some(polo => {
        const termA = resolveTerminal(polo.terminaleA, terminalData);
        const termB = resolveTerminal(polo.terminaleB, terminalData);
        return (termA && termA.peel > 0) || (termB && termB.peel > 0);
    });
};
